import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosolapurcab() {



const cardData = {
  keyword: " Mumbai to Solapur Cab   ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Solapur cab package services, ensuring a seamless and stress-free journey for pilgrims, families, and leisure travelers. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Ayodhya convenient and safe. The journey covers approximately 1,300–1,350 km via NH27 and NH330, typically taking 22–24 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized cab packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Ayodhya cab travel.",

topPlaces: [
  {
    title: "Siddheshwar Temple",
    description: "Siddheshwar Temple is one of Solapur’s most important religious landmarks dedicated to Lord Siddheshwar. Located near a serene lake, it attracts devotees throughout the year and is especially vibrant during the annual fair, offering a peaceful spiritual atmosphere."
  },
  {
    title: "Bhuikot Fort",
    description: "Bhuikot Fort is a historic fort in the heart of Solapur showcasing remnants of medieval architecture and defensive structures. Visitors can explore its massive stone walls and learn about the city’s historical significance under various dynasties."
  },
  {
    title: "Great Indian Bustard Sanctuary",
    description: "Great Indian Bustard Sanctuary near Solapur is a protected area dedicated to conserving the endangered Great Indian Bustard. Nature lovers can explore its grasslands and observe diverse bird species in their natural habitat."
  },
  {
    title: "Shri Markandeya Temple",
    description: "Shri Markandeya Temple is a well-known ancient temple in Solapur dedicated to Lord Shiva. It is admired for its religious importance, traditional architecture, and peaceful surroundings that attract devotees and tourists alike."
  },
  {
    title: "Hipparga Lake",
    description: "Hipparga Lake is a calm and scenic water body near Solapur, popular for evening visits and photography. It offers a relaxing environment for families and travelers seeking peaceful natural surroundings."
  },
  {
    title: "Siddheshwar Lake",
    description: "Siddheshwar Lake surrounds the famous Siddheshwar Temple and adds to the spiritual beauty of the area. Visitors enjoy peaceful walks along the lake and scenic views, especially during sunrise and sunset."
  },
  {
    title: "Solapur Science Centre",
    description: "Solapur Science Centre is an educational attraction featuring interactive science exhibits and models. It is a great place for students, families, and curious visitors interested in learning through hands-on experiences."
  },
  {
    title: "Revansiddha Temple",
    description: "Revansiddha Temple is a popular pilgrimage site located near Solapur known for its spiritual importance and scenic surroundings. It attracts devotees seeking blessings and a peaceful temple experience."
  },
  {
    title: "Hutatma Garden",
    description: "Hutatma Garden is a well-maintained public park in Solapur featuring greenery, walking paths, and memorial structures. It is a popular spot for relaxation and evening walks in the city."
  },
  {
    title: "Kambar Talav",
    description: "Kambar Talav is a scenic lake in Solapur offering peaceful surroundings and natural beauty. It is ideal for evening relaxation, photography, and enjoying calm moments away from the city crowd."
  }
],



services: [
{
name: "Mumbai to Solapur Cab Service",
description: "Mumbai to Solapur cab service offers a comfortable and reliable travel solution for passengers looking for a safe and hassle-free road journey. Solapur is one of Maharashtra's major commercial and cultural cities, known for its textile industry, historical landmarks, and famous religious destinations. This service is ideal for business travelers, families, tourists, and individuals who prefer private transportation over public transport. The journey is covered through well-maintained highways, ensuring smooth and convenient travel. Professional drivers with extensive route knowledge provide safe driving, timely arrivals, and comfortable rest stops. Customers can choose from sedan, SUV, and premium vehicles according to their travel needs. Doorstep pickup from Mumbai and direct drop at hotels, residences, offices, or any location in Solapur ensure maximum convenience. With transparent pricing, easy booking, and 24x7 customer support, this cab service guarantees a pleasant and stress-free travel experience."
},
{
name: "Mumbai to Solapur Taxi",
description: "Mumbai to Solapur taxi service provides dependable and comfortable transportation for long-distance intercity travel. This service is suitable for business professionals, families, tourists, and solo travelers seeking flexible travel schedules. Vehicles are clean, well-maintained, and designed for comfortable highway journeys. Experienced drivers ensure safe driving and efficient route management throughout the trip. Customers can choose from sedan, SUV, and premium vehicle options according to their budget and travel requirements. Flexible pickup locations across Mumbai make travel convenient. It ensures a smooth and enjoyable travel experience."
},
{
name: "Mumbai to Solapur Cab Booking",
description: "Mumbai to Solapur cab booking allows customers to reserve their preferred vehicle quickly with instant confirmation and flexible scheduling. Travelers can choose vehicle type, pickup location, travel date, and preferred timing according to their convenience. Transparent pricing ensures complete clarity without hidden charges. Secure online booking options and multiple payment methods simplify the reservation process. Dedicated customer support assists customers throughout the booking journey. It is the easiest way to organize a comfortable intercity trip. It ensures a well-planned and hassle-free travel experience."
},
{
name: "Solapur Tour Package from Mumbai by Cab",
description: "Solapur tour package from Mumbai by cab offers a complete travel experience for tourists, families, and business visitors. The package includes pickup from Mumbai, comfortable road travel, and sightseeing at popular attractions in and around Solapur. Travelers can customize the itinerary, duration, and destinations according to their preferences. Professional drivers ensure safe and comfortable transportation throughout the journey. Well-maintained vehicles provide a relaxing travel experience. It offers a convenient and personalized travel solution."
},
{
name: "Mumbai to Solapur Outstation Cab",
description: "Mumbai to Solapur outstation cab service provides dependable long-distance transportation with comfort and safety. This service is suitable for families, corporate travelers, tourists, and groups. Vehicles are regularly serviced to ensure reliable highway performance. One-way and round-trip travel options are available according to customer requirements. Professional drivers ensure safe navigation and timely arrivals. Pickup from multiple locations across Mumbai adds convenience. It guarantees a comfortable and worry-free travel experience."
},
{
name: "Mumbai to Solapur Taxi Fare",
description: "Mumbai to Solapur taxi fare is designed to be transparent, affordable, and competitive for every traveler. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive complete fare details including toll charges and driver allowance wherever applicable. Affordable sedan, SUV, and premium vehicle options suit different budgets. No hidden charges ensure complete transparency and trust. Flexible pricing provides excellent value for long-distance travel."
},
{
name: "Cheap Cab Mumbai to Solapur",
description: "Cheap cab Mumbai to Solapur offers budget-friendly travel options without compromising comfort, reliability, or safety. This service is ideal for students, families, tourists, and business travelers looking for economical transportation. Sedan vehicles provide affordable pricing for long-distance journeys. Transparent billing ensures complete fare clarity before the trip begins. Experienced drivers ensure smooth and safe highway travel. Flexible booking options simplify travel planning. It is an excellent choice for affordable intercity transportation."
},
{
name: "Mumbai to Solapur SUV Taxi",
description: "Mumbai to Solapur SUV taxi is an excellent option for families, groups, and travelers carrying extra luggage. Spacious seating, superior comfort, and excellent highway performance make SUVs ideal for long-distance travel. Professional drivers ensure safe and comfortable driving throughout the journey. This option provides additional convenience for group travel. Premium comfort enhances the overall travel experience. It ensures a smooth and relaxing road trip."
},
{
name: "Mumbai to Solapur Sedan Cab",
description: "Mumbai to Solapur sedan cab is a preferred option for solo travelers, couples, and small families looking for economical and comfortable transportation. Sedans offer comfortable seating, smooth highway performance, and excellent fuel efficiency. This service combines affordability with convenience for intercity travel. Professional drivers ensure safe and timely transportation. Flexible pickup options improve customer convenience. It guarantees a comfortable and pleasant travel experience."
},
{
name: "Private Cab Mumbai to Solapur",
description: "Private cab Mumbai to Solapur offers an exclusive travel experience with complete privacy, flexibility, and personalized service. Travelers can customize travel schedules, routes, and stopovers according to their preferences. Professional drivers ensure safe, reliable, and comfortable transportation throughout the journey. Well-maintained vehicles provide premium comfort for long-distance travel. It is ideal for business travelers, families, and tourists seeking private transportation. It guarantees flexibility, convenience, and peace of mind."
},
{
name: "AC Taxi Mumbai to Solapur",
description: "AC taxi Mumbai to Solapur provides comfortable air-conditioned transportation for a pleasant and refreshing road journey throughout the year. Clean interiors, efficient cooling systems, and comfortable seating enhance passenger comfort during long-distance travel. Suitable for business travelers, families, and tourists, this service offers flexible booking and timely pickup. Professional drivers ensure safe and reliable travel. It guarantees a smooth, comfortable, and enjoyable journey experience."
}
],

tableData: [
["Mumbai to Solapur Cab Service","Mumbai to Solapur Taxi"],
["Mumbai to Solapur Cab Booking","Solapur Tour Package from Mumbai by Cab"],
["Mumbai to Solapur Outstation Cab","Mumbai to Solapur Taxi Fare"],
["Cheap Cab Mumbai to Solapur","Mumbai to Solapur SUV Taxi"],
["Mumbai to Solapur Sedan Cab","Private Cab Mumbai to Solapur"],
["AC Taxi Mumbai to Solapur","Mumbai to Solapur Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers Mumbai to Solapur cab packages designed for a smooth, comfortable, and hassle-free journey for business travelers, families, and tourists."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai to Solapur route, ensuring safe driving, proper route navigation, and timely arrival at your destination."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Solapur cab bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Solapur cab service is available 24 hours a day. Whether you need an early morning pickup or a late-night departure, we are always ready to serve you."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are fully air-conditioned, regularly sanitized, and well maintained to provide maximum comfort throughout your journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible one-way, round-trip, and multi-day cab packages from Mumbai to Solapur according to your travel requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for solo travelers, families, and groups."
  },
  {
    WhyChooseheading: "Trusted Mumbai to Solapur Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by thousands of customers for Mumbai to Solapur cab bookings because of our punctual drivers, clean vehicles, professional service, and customer satisfaction."
  }
]
};

const faqData = [
  {
    question: "Do you provide Mumbai to Solapur cab service?",
    answer: "Yes, Velocity Cabs provides reliable Mumbai to Solapur cab service for one-way, round-trip, and outstation travel."
  },
  {
    question: "How far is Solapur from Mumbai?",
    answer: "The distance between Mumbai and Solapur is approximately 400 to 450 km, and the journey usually takes around 7 to 9 hours depending on traffic and road conditions."
  },
  {
    question: "Is cab service available 24 hours?",
    answer: "Yes, our Mumbai to Solapur cab service operates 24/7 for customer convenience."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab?",
    answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Solapur."
  },
  {
    question: "Are vehicles air-conditioned?",
    answer: "Yes, all our vehicles are fully air-conditioned to ensure a comfortable travel experience."
  },
  {
    question: "Can I book the cab online?",
    answer: "Yes, customers can easily book Mumbai to Solapur cabs online or by calling our customer support team."
  },
  {
    question: "Do you provide sightseeing packages in Solapur?",
    answer: "Yes, we offer customized Solapur sightseeing and outstation cab packages based on customer requirements."
  },
  {
    question: "Is advance booking recommended?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability, especially during weekends and holidays."
  },
  {
    question: "Are vehicles sanitized regularly?",
    answer: "Yes, all our vehicles are cleaned and sanitized regularly to maintain high standards of hygiene and passenger safety."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "A smooth and comfortable journey from Mumbai to Solapur. The cab was punctual, well-maintained, and the long drive felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Mumbai to Solapur cab service was very reliable. The vehicle was clean, the ride was steady, and the entire travel experience felt safe and hassle-free.",
    rating: 5
  }
];





















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const mumbaiSolapurCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Solapur Cab Booking | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Solapur for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Solapur Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Solapur",
        "description": "Private cab from Mumbai to Solapur for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Solapur Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Solapur with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Solapur Cab Booking | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Solapur for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiSolapurCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosolapurcab;